
export const get_intellifox_url = () => {
  return 'https://app.intellifox.com'
}
